// Centralized color and background constants for chat skinning
// Update this file to change chat theme colors in one place

export const ChatColors = {
  filelist: {
    BORDER: '1px solid rgba(255, 255, 255, 0.08)',
    BG: 'rgba(255, 255, 255, 0.06)',
    INPUTBAR_GRADIENT:
      'linear-gradient(180deg, rgba(0, 0, 0, 0) 0%, rgba(0, 0, 0, 0.35) 60%)',
  },
  filechip: {
    BG: 'rgba(57, 87, 225, 0.18)',
    BORDER: '1px solid rgba(57, 87, 225, 0.35)',
    TEXT: '#fff',
    REMOVE_BG: 'rgba(57, 87, 225, 0.25)',
    REMOVE_HOVER_BG: 'rgba(57, 87, 225, 0.4)',
  },
  bubble: {
    USER_BG: '#009cfc',
    ASSISTANT_BG:
      'radial-gradient(2604.22% 188.23% at -17.56% -47%, rgba(255, 255, 255, 0.16) 0%, rgba(255, 255, 255, 0.00) 100%)',
    BORDER: '1px solid rgba(255, 255, 255, 0.07)',
    TEXT: '#fff',
  },
  chat: {
    BG: '#fff',
    BG_DARK: '#0f1215',
    TEXT: '#fff',
  },
  overlay: {
    SHADOW_BOTTOM: '0 0 30px rgba(128, 128, 128, 0.3)',
    SHADOW_RIGHT: '-8px 0 30px rgba(0, 0, 0, 0.3)',
    CONTAINER_BG: '#0f1215',
    INNER_BG: '#fff',
    CONTAINER_RADIUS: '16px 16px 0 0',
  },
  trigger: {
    BUTTON_GRADIENT:
      'linear-gradient(135deg, #2a3d5f 0%, #4a6bea 30%, #6b89f0 50%, #5d7ee8 70%, #3e5a88 100%)',
    BUTTON_COLOR: '#fff',
    BUTTON_RADIUS: '8px',
    BUTTON_SHADOW: '0 8px 16px rgba(107, 137, 240, 0.4)',
  },
  progress: {
    TRACK_BG: 'rgba(255, 255, 255, 0.06)',
    BUTTON_BG: 'rgba(255, 255, 255, 0.06)',
    BUTTON_COLOR: '#009cfc',
    BUTTON_HOVER_BG: '#009cfc',
    BUTTON_HOVER_COLOR: '#fff',
    GRADIENT_WHITE:
      'linear-gradient(90deg, rgba(255, 255, 255, 0.9) 0%, rgba(255, 255, 255, 1) 100%)',
    GRADIENT_BLUE: 'linear-gradient(90deg, #0085d7 0%, #009cfc 100%)',
  },
  panel: {
    BACKDROP_BG: 'rgba(0, 0, 0, 0.64)',
    SHADOW: 'rgba(0, 0, 0, 0.25)',
    GRADIENT_START: '#0d0d0d',
    GRADIENT_MID: '#000000',
    GRADIENT_END: '#191919',
    TASK_COMPLETE_GREEN: '#2ecc40',
    TASK_NOT_STARTED_GREY: '#b0b7c3',
    TASK_IN_PROGRESS_BLUE: '#009cfc',
    TASKITEM_HOVER_BG: 'rgba(255, 255, 255, 0.06)',
    BORDER_COLOR: 'rgba(255, 255, 255, 0.08)',
    OUTLINE_COLOR: 'rgba(255, 255, 255, 0.28)',
    PRIMARY_BLUE: '#009cfc',
    STATUS_WHITE: '#fff', // Palette.white can be used if imported
  },
  header: {
    BORDER: '1px solid rgba(255, 255, 255, 0.08)',
    BG: 'rgba(0, 0, 0, 0.64)',
    TEXT: '#fff',
    ICON_BG: '#fff',
    ICON_OPACITY: 0.94,
    ACTION_ICON: '#009cfc',
  },
  messagelist: {
    CONTAINER_BG: 'transparent',
    PADDING: '1.25rem 1.25rem 6.5rem 1.25rem',
    GAP: '1.35rem',
    SCROLLBAR_TRACK: 'rgba(255, 255, 255, 0.06)',
    SCROLLBAR_THUMB: 'rgba(255, 255, 255, 0.06)',
    SCROLLBAR_THUMB_HOVER: '#009cfc',
    MARKDOWN_CODE_BG: 'rgba(255, 255, 255, 0.06)',
    MARKDOWN_PRE_BG: 'rgba(255, 255, 255, 0.06)',
    BLOCKQUOTE_BORDER: 'rgba(255, 255, 255, 0.08)',
    BLOCKQUOTE_TEXT: '#fff',
    LINK: '#009cfc',
    HR: 'rgba(255, 255, 255, 0.28)',
    TABLE_BORDER: 'rgba(255, 255, 255, 0.28)',
    TABLE_HEADER_BG: 'rgba(255, 255, 255, 0.06)',
    LOADING_TEXT: '#fff',
  },
};
